import { ComponentPropsWithoutRef } from 'react';
import { Meter } from '@givebutter/primitives/meter';
import { pluralize } from '@givebutter/util';
import { useCurrencySymbol } from 'customHooks/useCurrencySymbol';
import { twMerge } from 'tailwind-merge';
import { Member, Team } from 'types/domain';

interface RaiseTotalProps extends ComponentPropsWithoutRef<'div'> {
    model: Team | Member;
}

const RaisedTotal = (props: RaiseTotalProps) => {
    const { model, className } = props;
    const {
        goal: goalConsumer,
        donors,
        raised_formatted,
        goal_formatted,
        raised_percentage,
    } = model;
    const currencySymbol = useCurrencySymbol();
    const showGoal = parseFloat(goalConsumer ?? '0') > 0;

    return (
        <div className={twMerge('flex flex-col gap-1', className)}>
            <div className={'flex flex-col'}>
                <div
                    className={'flex flex-col items-baseline gap-1 md:flex-row md:justify-between'}
                >
                    <div className={'flex items-baseline gap-1'}>
                        <p className={'font-medium'}>
                            {currencySymbol}
                            {raised_formatted}
                        </p>
                        {showGoal && (
                            <p className={'text-xs'}>
                                of{' '}
                                <span className={'font-medium'}>
                                    {currencySymbol}
                                    {goal_formatted}
                                </span>
                            </p>
                        )}
                    </div>
                    <p className={'text-xs font-medium'}>
                        {donors} {pluralize(donors, 'supporter')}
                    </p>
                </div>
            </div>
            <Meter
                type="line"
                value={raised_percentage}
                aria-label="Raised Percentage"
                size="md"
                variant="success"
            />
        </div>
    );
};

export { RaisedTotal };
